import React from 'react';
import { Navbar } from '../components/Navbar';
import { ConsularAffairs } from '../components/ConsularAffairs';
import { Footer } from '../components/Footer';
export function ConsularPage() {
  return <div className="font-nunito w-full min-h-screen overflow-x-hidden" data-id="element-3479">
      <Navbar data-id="element-3480" />
      <main data-id="element-3481">
        <ConsularAffairs data-id="element-3482" />
      </main>
      <Footer data-id="element-3483" />
    </div>;
}